/*
 * @Author: your name
 * @Date: 2021-03-30 18:41:18
 * @LastEditTime: 2022-07-18 11:38:08
 * @LastEditors: leoqyli leoqyli@tencent.com
 * @Description: In User Settings Edit
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/js/utils/getDatasource/customeBase.js
 */
// import getDatasourceByType from './utils/getDatasourceByType';
// import filters from '../filters';

function getCustomerBaseByPagination(params) {
    return window.Vue.prototype.$_sAjax.get('/cl/CustomFields/GetCustomerByView', { params });
}

export default function (config) {
    // const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    let index = 0;
    let size = 30;
    let searchKeyWord;
    // 为啥非要把分页逻辑放在这里？ 因为接口太混乱，各个接口的分页逻辑可能完全不一样，放在这里可以各自定义分页逻辑
    try {
        index = config.params.index || index;
        size = config.params.size || size;
        searchKeyWord = config.params.searchParams.name;
        // eslint-disable-next-line no-empty
    } catch (err) {}
    // const { page, size } = config.base.config.pageInfo;
    return new Promise((resolve, reject) => {
        const params = {
            page: index,
            size,
        };
        const defaultParams = {
            sortKey: 'lastModifiedTime',
            sortType: 'desc',
        };
        let ajaxParams = {
            ...defaultParams,
            ...params,
            ...{
                'filters[0][field]': 'Owner',
                'filters[0][operation]': '==',
                'filters[0][value]': 'all',
            },
        };
        if (searchKeyWord) {
            ajaxParams = {
                ...ajaxParams,
                ...{
                    keywords: searchKeyWord,
                },
            };
        }
        getCustomerBaseByPagination(ajaxParams)
            .then((res) => {
                const list = res.records.map(x => ({
                    face: x.avatar,
                    uin: x.id,
                    id: x.id,
                    name: x.Name,
                }));
                resolve({ list, params: { pageInfo: { index: index + 1, size } } });
            })
            .catch((err) => {
                reject(err);
            });
    });
}
